import { injectPreviewBridge } from "@/lib/brand-site-preview-nav";

/** 对齐 BrandSiteLivePreview：可跑脚本看效果，禁止顶层导航逃逸。 */
export const HERMES_HTML_PREVIEW_SANDBOX = "allow-scripts" as const;

export const HERMES_HTML_PREVIEW_FOOTNOTE =
  "满意后点「写入草稿」。会把当前预览原文写入左边草稿并刷新预览。" as const;

export type HermesHtmlPreviewSummary = {
  id: number;
  slug: string;
  title?: string | null;
  byte_size?: number;
};

export type HermesHtmlPreviewDetail = HermesHtmlPreviewSummary & {
  /** 展示用（已展开 Liquid） */
  html: string;
  /** 写入草稿用的 Liquid 源码；缺省时回退 html */
  source_html?: string | null;
  /** 品牌站公网 origin；聊天预览 iframe 改写 /_c456/a/… 时使用 */
  asset_base_url?: string | null;
};

/** 去掉末尾斜杠，便于拼接 /_c456/a/… */
export function normalizeHermesHtmlPreviewAssetBaseUrl(baseUrl: string | null | undefined): string | null {
  const trimmed = baseUrl?.trim();
  if (!trimmed) return null;
  return trimmed.replace(/\/+$/, "");
}

/** 将 HTML 内相对 /_c456/a/{slug} 改写到品牌站公网 origin（不改已绝对化的 URL）。 */
export function rewriteC456AssetPathsInHtml(
  html: string,
  assetBaseUrl: string | null | undefined,
): string {
  const base = normalizeHermesHtmlPreviewAssetBaseUrl(assetBaseUrl);
  if (!base || !html) return html;

  return html.replace(/(?<![\w:])\/_c456\/a\/([a-z0-9]{8,})/gi, (match) => `${base}${match}`);
}

/**
 * 聊天预览 iframe 的 srcDoc：改写素材路径 + 注入站内导航桥（防 srcDoc 白屏）。
 * 不含点选运行时（pick:false）。
 */
export function buildHermesHtmlPreviewSrcDoc(
  html: string,
  assetBaseUrl: string | null | undefined,
): string {
  return injectPreviewBridge(rewriteC456AssetPathsInHtml(html, assetBaseUrl), { pick: false });
}

/** 在同条消息的预览列表里按 slug 找页（index / 空视为首页）。 */
export function findHermesPreviewBySlug(
  previews: readonly HermesHtmlPreviewSummary[],
  slug: string,
): HermesHtmlPreviewSummary | undefined {
  const want = !slug || slug === "index" ? "index" : slug;
  return previews.find((item) => {
    const got = !item.slug || item.slug === "index" ? "index" : item.slug;
    return got === want;
  });
}
